import { Reaction, ReactionType } from '../model/post.types';

export const applyReactionToggle = (
  reactions: Reaction[],
  type: ReactionType,
): Reaction[] => {
  const existing = reactions.find((reaction) => reaction.type === type);

  if (existing === undefined) {
    return [...reactions, { type, count: 1, isToggled: true }];
  }

  if (existing.isToggled && existing.count === 1) {
    return reactions.filter((reaction) => reaction.type !== type);
  }

  return reactions.map((reaction) =>
    reaction.type === type
      ? {
          ...reaction,
          isToggled: !reaction.isToggled,
          count: reaction.isToggled ? reaction.count - 1 : reaction.count + 1,
        }
      : reaction,
  );
};
